import { useEffect } from "react";

const SITE_URL = (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, "");
const NOINDEX_PATHS = ["/admin"];

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href, hreflang) => {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const absolute = (u) => (u && u.startsWith("/") ? `${SITE_URL}${u}` : u);

export function useSEO({ title, description, image, lang = "fr", jsonLd, type = "website" }) {
  useEffect(() => {
    const path = window.location.pathname.replace(/\/$/, "");
    const url = `${SITE_URL}${path}${path ? "" : "/"}`;
    const img = absolute(image);
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", NOINDEX_PATHS.some((p) => path.startsWith(p)) ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("property", "og:locale", lang === "fr" ? "fr_FR" : "en_GB");
    setMeta("property", "og:site_name", "Palissiere Motor Group");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
    setLink("canonical", url);
    setLink("alternate", `${url}?lang=fr`, "fr");
    setLink("alternate", `${url}?lang=en`, "en");
    setLink("alternate", url, "x-default");
    let script = document.getElementById("pmg-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.id = "pmg-jsonld";
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) script.remove();
  }, [title, description, image, lang, jsonLd, type]);
}

export function useNoIndex() {
  useEffect(() => {
    setMeta("name", "robots", "noindex, nofollow");
    return () => setMeta("name", "robots", "index, follow, max-image-preview:large");
  }, []);
}

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${SITE_URL}/#organization`,
      name: "Palissiere Motor Group",
      alternateName: ["Palissiere Motor", "PMG"],
      url: `${SITE_URL}/`,
      email: "idrissa@palissieremotorgroup.com",
      telephone: "+33641349733",
      description: "Sourcing automobile, intermédiation et vente de véhicules de luxe, de prestige, sportifs et d'exception en France et à l'international.",
      knowsLanguage: ["fr", "en"],
      areaServed: ["FR", "MC", "CH", "DE", "IT", "BE", "NL", "GB", "ES", "AE"],
      contactPoint: [{ "@type": "ContactPoint", contactType: "sales", email: "idrissa@palissieremotorgroup.com", telephone: "+33641349733", availableLanguage: ["French", "English"] }],
    },
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      url: `${SITE_URL}/`,
      name: "Palissiere Motor Group",
      publisher: { "@id": `${SITE_URL}/#organization` },
      inLanguage: ["fr", "en"],
    },
  ],
};
